import React, {Component} from 'react';
import {Button, Input, message, Modal, Spin, Popconfirm} from "antd";
import StuffList from "./stuffList";
import StuffCard from "./stuffCard";
import {uuid} from "../utils";
import {getCurrentUser} from "../actions";
import {
    actForm,
    actData,
    actButton,
    actChoose,
    clickButtonId,
    actButtonList,
    actText,
    actProcess
} from "../components/activity/publicnew";
import {getMaterialById, preview, saveMaterial, saveStatusName, sendMaterial} from "../actions/weiChat";
import ChooseUserModal from "./chooseUserModal";
import WeiChatTagSelect from "./weiChatTagSelect";
import {Scrollbars} from "react-custom-scrollbars";
const { TextArea } = Input;

/** 节点数据 **/
let actTask = {
    lastId:null    //最后一个节点id，也就是当前所流转到的节点id
};

let win = window.top || window;

class EditMaterial extends Component {

    currentUser;

    publishTagId = 0;

    textareaModalTitle = '备注';

    callbackType = '';

    callback = () => {};

    constructor(props){
        super(props);
        this.state = {
            stuffList : [],
            btns:[],
            mediaCode: props.mediaCode,
            materialId: props.materialId,
            visible: false,
            statusName : "",
            loading: false,
            publishModalVisible: false,     // 发布时选择标签框
            textareaModalVisible : false,    // 撤回的备注框
            // isEditMaterial:props.isEditMaterial,
            // edit: props.edit
            remarksContent: "",
        };
        getCurrentUser((currentUser)=>{
            this.currentUser = currentUser;
            this.initAct();
        });
    }

    componentDidMount() {
        this.loadMaterial();
    }

    loadMaterial = () => {
        if(this.state.materialId > 0){
            getMaterialById({materialId : this.state.materialId}, (res) =>{
                if(res.statusName === '发布'){
                    this.canEdit = false;
                }
                this.setState({
                    stuffList : res.stuffList,
                    statusName : res.statusName
                })
            });
        }
    };

    initAct() {
        //避免加载上一次的流程数据
        actData.id = this.state.materialId;
        delete actProcess.processInstanceId;
        //入口按钮id
        actData.buttonId = 7;
        //当前用户名
        actData.userName = this.currentUser.account;
        //按钮容器id
        actData.docId = "btnArea";
        actButton.afterClickButton = this.advanceActiviti.bind(this);
        let that = this;
        actButton.init(()=>{
            actButton.getRemarks(function(remarks){
                if(remarks){
                    that.setState(prevState =>{
                        prevState.btns.push({
                            name : "查看备注",
                            type : "remarks"
                        });
                        return {
                            ...prevState,
                            remarksContent: remarks
                        }
                    });
                }
            })
        }, this.state.materialId, (btns)=>{
            if(btns.length > 0){
                btns.push({
                    name : "保存",
                    type : "save"
                })
            }
            btns.push({
                name : "预览",
                type : "preview"
            });
            if(this.state.statusName === '发布失败'){
                btns.push({
                    name : "发布",
                    type : "publish"
                });
            }
            this.setState({btns});

            actButton.submitOK =  () => {
                //关闭窗口
                this.props.onAdvance();
            };

            actButton.alert = function(res,call){
                if(res.state){
                    //成功提示  提示确定后  执行回调
                    message.success(res.msg,1,call);
                }else {
                    //失败提示
                    message.error(res.msg,1)
                }
            };

            actButton.load = () =>{
                this.setState({
                    loading : true
                })
            };

            actButton.closeAll = () =>{
                this.setState({
                    loading : false
                })
            };

            actChoose.getChoose = (data,type,callback) =>{
                actButton.closeAll();
                if(!this.state.stuffList || this.state.stuffList.length === 0){
                    message.warn("请至少添加一个图文");
                    this.setState({
                        loading : false
                    })
                    return;
                }
                this.refs.chooseUserModal.showModal(data,(accountArray) =>{
                    let callbackValue ={};
                    callbackValue.activitiUsers = accountArray;
                    callbackValue.type = type;
                    callback(callbackValue);
                });
            };

            actText.getText = (data,type,callback) =>{
                actButton.closeAll();
                if(data){
                    this.textareaModalTitle = data.title;
                }
                this.callbackType = type;
                this.callback = callback;
                this.setState({
                    textareaModalVisible : true
                });
            };

            actButton.callActRevert = (processInstanceId,endcall) =>{
                actButton.terminate(null,() =>{
                    actButton.end("草稿",()=>{
                        if(typeof(actButton.name) != "undefined" && actButton.name && actButton.name.length > 0 ){
                            let layerMsg = actButton.name + '成功';
                            actButton.alert({msg:layerMsg,state:true},actButton.submitOK);
                        }else{
                            actButton.alert({msg:"撤回失败！",state:true},actButton.submitOK);
                        }
                        actForm.users={};
                    })
                });
            };

            actButton.endFunction = (call,statusName) =>{
                if(!statusName)
                    statusName = this.statusNameTemp;
                let params = {
                    materialId: this.materialId,
                    statusName: statusName === '发布' ? "发布中" : statusName
                };
                saveStatusName(params,call);
            };

            actButton.callPublish = (call,endcall) => {
                if(!this.state.stuffList || this.state.stuffList.length === 0){
                    message.warn("请至少添加一个图文");
                    this.setState({
                        loading : false
                    })
                    return;
                }
                this.setState({
                    publishModalVisible : true
                });
                this.callback = endcall;
            };

            actButton.getRemarks = (call) => {
                //加载审核意见等信息
                if( actProcess.processInstanceId)
                {
                    let taskList = actButton.getTaskList(actProcess.processInstanceId,function(taskList){
                        if(taskList && taskList instanceof Array && taskList.length > 0 )
                            actTask.lastId = taskList[taskList.length - 1].id;
                        actButton.getRemarksFromActTask(call);
                    });
                }
            };

            actButton.getRemarksFromActTask = (call) => {
                actButton.getFrom(actTask.lastId,function(thisForm){
                    if(thisForm == undefined || thisForm.fields == undefined || thisForm.fields.length == 0)
                        return;
                    thisForm.fields.forEach(function (item,index) {
                        if(item.id == "otherData" && item.value && item.value.length > 0){
                            let otherData = JSON.parse(item.value);
                            if(otherData != null &&  otherData.hasOwnProperty("remarks")){
                                if(typeof call == "function"){
                                    call(actButton.escape(otherData.remarks));
                                }else if(typeof showRemarks == "function"){
                                    win.showRemarks(actButton.escape(otherData.remarks));
                                }
                            }
                        }
                    })
                });
            }
        });
    }

    publish = () => {
        if(!this.state.stuffList || this.state.stuffList.length === 0){
            message.warn("请至少添加一个图文");
            this.setState({
                loading : false
            })
            return;
        }
        this.callback = () =>{
            this.saveMaterial(() =>{
                let params = {
                    materialId : this.state.materialId,
                    mediaCode : this.state.mediaCode,
                    tagId : this.publishTagId
                };
                sendMaterial(params,() =>{
                    message.success("发布中，请稍后！")
                });
            })
        };
        this.setState({
            publishModalVisible : true
        });
    };

    materialId = this.props.materialId;

    statusNameTemp = "";

    /*推进流程时执行*/
    advanceActiviti = (clickButtonId, call)=>{
        if(!this.state.stuffList || this.state.stuffList.length === 0){
            message.warn("请至少添加一个图文");
            this.setState({
                loading : false
            });
            return;
        }
        this.saveMaterial(call);
    };

    saveMaterial = (callback) => {
        if(!this.state.stuffList || this.state.stuffList.length === 0){
            message.warn("请至少添加一个图文");
            this.setState({
                loading : false
            });
            return;
        }
        let stuffJsonStr = [];
        for(let index = 0; index < this.state.stuffList.length; index ++){
            let item = this.state.stuffList[index];
            if(item.url && !/^(http|https):\/\/.+/.test(item.url)){
                message.error("第"+ (index + 1) +"篇图文的原文链接不合法");
                return;
            }else {
                stuffJsonStr.push({
                    stuffId : item.id,
                    url : item.url,
                    author : item.author,
                    labelNames : item.labelNames.join(",")
                })
            }
        }
        let params = {
            materialId : this.state.materialId,
            mediaCode : this.state.mediaCode,
            stuffJsonStr : JSON.stringify(stuffJsonStr)
        };
        saveMaterial(params, (data) =>{
            this.materialId = data.id;
            if(callback){
                data.statusName = this.statusNameTemp;
                data.publishTagId = this.publishTagId;
                actForm.values.jsondata = {};
                actForm.values.jsondata.jsondata = JSON.stringify(data);
                actForm.values.jsondata.serviceId = data.id;
                callback(clickButtonId);
            }else {
                actButton.alert({msg:"保存成功！",state: true},actButton.submitOK);
            }
        });
    };

    addStuff(stuff){
        let prevState = this.state;
        for(let i = 0; i < prevState.stuffList.length; i++){
            let oldStuff = prevState.stuffList[i];
            if(oldStuff.id === stuff.id){
                message.info("请勿重复添加");
                return;
            }
        }
        if(prevState.stuffList && prevState.stuffList.length >= 8){
            message.info("最多只能添加8个图文");
            return;
        }
        this.setState(prevState=>{
            let newStuff = Object.assign({},stuff);
            newStuff.addStuff = ()=>{};
            newStuff.openCheckedMode=true;
            prevState.stuffList.push(newStuff);
            prevState.stuffList.map((item, index)=>{
                item.type = index === 0? "big":"small";
            });
            return prevState;
        })
    }

    delStuff(stuff){
        this.setState(prevState=>{
            let newStuffList = [];
            for(let i = 0; i < prevState.stuffList.length; i++){
                let oldStuff = prevState.stuffList[i];
                if(oldStuff.id !== stuff.id){
                    newStuffList.push(oldStuff);
                }
            }
            prevState.stuffList = newStuffList;
            prevState.stuffList.map((item, index)=>{
                item.type = index === 0? "big":"small";
            });
            return prevState;
        })
    }

    upStuff(stuff){
        this.setState(prevState=>{
            let currentIndex = -1;
            for(let i = 0; i < prevState.stuffList.length; i++){
                let oldStuff = prevState.stuffList[i];
                if(oldStuff.id === stuff.id){
                    currentIndex = i;
                }
            }
            if (currentIndex === -1) {
                return prevState;
            }
            prevState.stuffList = this.upRecord(prevState.stuffList, currentIndex);
            prevState.stuffList.map((item, index)=>{
                item.type = index === 0? "big":"small";
            });
            return prevState;
        })
    }

    downStuff(stuff){
        this.setState(prevState=>{
            let currentIndex = -1;
            for(let i = 0; i < prevState.stuffList.length; i++){
                let oldStuff = prevState.stuffList[i];
                if(oldStuff.id === stuff.id){
                    currentIndex = i;
                }
            }
            if (currentIndex === -1) {
                return prevState;
            }
            prevState.stuffList = this.downRecord(prevState.stuffList, currentIndex);
            prevState.stuffList.map((item, index)=>{
                item.type = index === 0? "big":"small";
            });
            return prevState;
        })
    }

    // 上移
    upRecord (arr, $index) {
        if($index == 0) {
            return arr;
        }
        return this.swapItems(arr, $index, $index - 1);
    };

    // 下移
    downRecord (arr, $index) {
        if($index == arr.length -1) {
            return arr;
        }
        return this.swapItems(arr, $index, $index + 1);
    };

    swapItems(arr, index1, index2) {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0];
        return arr;
    };

    reloadStuff(stuff){
        this.setState(prevState=>{
            let newStuffList = [];
            for (let i = 0; i < prevState.stuffList.length; i++) {
                let oldStuff = prevState.stuffList[i];
                if(oldStuff.id === stuff.id){
                    newStuffList.push(stuff);
                } else {
                    newStuffList.push(oldStuff);
                }
            }
            prevState.stuffList = newStuffList;
            prevState.stuffList.map((item, index)=>{
                item.type = index === 0? "big":"small";
            });
            return prevState
        });
        this.refs.stuffList.updateDataOne(stuff);
    }

    preview = () => {
        this.setState({
            visible: true,
        });
    };

    previewHandleOk = e => {
        this.setState({
            visible: false,
            loading : true
        });
        // 先保存再调用预览接口
        this.advanceActiviti(-1, () =>{
            let weiChatCode = this.refs.weiChatCode.state.value;
            preview({materialId: this.materialId, weiChatCode},(res) =>{
                this.setState({
                    loading : false
                });
                if(res.errcode === 0){
                    message.success("已发送至手机，请查收")
                }else if(res.code === 101) {
                    const config = {
                        title: '微信公众号拒绝接收当前图片，请更换！',
                        content: <img src={res.message} height={200}/>,
                        okText:'确定'
                    };
                    Modal.error(config)
                }else {
                    message.error(res.errmsg || res.message);
                }
            })
        });
    };

    previewHandleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    publishHandleOk = () => {
        let tagId = this.weiChatTagSelect.checkedTagId;
        let restCount = this.weiChatTagSelect.state.restCount;
        if(restCount < 1){
            message.warn("当前群发次数已用完");
            return;
        }
        this.publishTagId = tagId;
        this.setState({
            publishModalVisible : false
        });
        this.callback(true);
    };

    publishHandleCancel = () => {
        this.setState({
            publishModalVisible : false
        })
    };

    onClick = (type, index) => {
        if(!this.state.stuffList || this.state.stuffList.length === 0){
            message.warn("请至少添加一个图文");
            this.setState({
                loading : false
            });
            return;
        }
        if(type === "save"){
            this.advanceActiviti(-1)
        }else if(type === "preview"){
            this.preview();
        }else if(type === "publish"){
            this.publish();
        }else if(type === "remarks"){
            Modal.info({title:this.state.remarksContent})
        }else{
            this.statusNameTemp = actButtonList.buttonConfigList[index].name;
            actButton.actButtonClick(index);
        }
    };

    weiChatTagSelect;

    remarks;

    canEdit = true;

    textareaHandleOk = () =>{
        let remarks = this.remarks.state.value;
        if(remarks && remarks.length > 150){
            message.error("备注信息不得超过150个字符");
            return;
        }
        let callbackValue ={};
        callbackValue.remarks = remarks;
        callbackValue.type = this.callbackType;
        this.callback(callbackValue);
        this.setState({
            textareaModalVisible : false
        })
    };

    textareaHandleCancel = () =>{
        this.setState({
            textareaModalVisible : false
        })
    };

    render() {
        let height = window.$(window).height() * 0.8;
        let btnHeight = 55;
        let contentHeight = height - btnHeight;
        return (<div>
                <Spin spinning={this.state.loading} >
                    <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} height={height}>
                        <tbody>
                        <tr>
                            <td height={contentHeight} width={370} style={{borderRight:"1px solid #e8e8e8"}}>
                                <StuffList ref={"stuffList"} isEditMaterial={true} findAll={false}
                                           addStuff={this.addStuff.bind(this)}
                                           contentHeight={contentHeight}
                                           currentMedia={this.props.mediaCode} />
                            </td>
                            <td align={"center"} valign={"middle"} style={{position:"relative",overflow:"hidden"}}>
                                <Scrollbars style={{position:'relative !important'}}>
                                    <div style={{height:contentHeight,display:'flex',alignItems:'center'}}>
                                        <div style={{width:"400px",margin:'auto'}}>
                                            <StuffCard isEditMaterial={true} stuffList={this.state.stuffList} openCheckedMode={true}
                                                       canEdit={this.canEdit}
                                                       delStuff={this.delStuff.bind(this)}
                                                       isMerge={true} ref={"stuffCard"}
                                                       upStuff={this.upStuff.bind(this)}
                                                       downStuff={this.downStuff.bind(this)}
                                                       reloadStuff={this.reloadStuff.bind(this)}
                                                       contentHeight={contentHeight}
                                                       isOpenEditAttr={true}
                                                       statusName={this.state.statusName}
                                            />

                                        </div>
                                    </div>
                                </Scrollbars>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} id={"btnArea"} style={{padding:"10px 0 10px 10px",borderTop:"1px solid #e8e8e8",background:"#F8F8F8"}} align={"right"}>
                                {this.state.btns.map((btn, index)=>{
                                    return btn.type === 'preview' ?
                                        (<Popconfirm placement="topLeft" title={"预览之前会将内容暂存，确定继续预览"} onConfirm={() => this.onClick(btn.type, index)} okText="确认" cancelText="取消">
                                            <Button key={uuid()}
                                                    type={"primary"}
                                                    style={{marginRight:"10px"}}>{btn.name}</Button>
                                        </Popconfirm>) :
                                        (<Button key={uuid()}
                                            onClick={() => this.onClick(btn.type, index)}
                                            type={btn.name !== "发布"?"normal":"primary"}
                                            style={{marginRight:"10px"}}>{btn.name}
                                        </Button>);
                                })}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </Spin>
                <Modal
                    title="发送到手机预览"
                    visible={this.state.visible}
                    onOk={this.previewHandleOk}
                    onCancel={this.previewHandleCancel}
                >
                    <Input ref={"weiChatCode"} placeholder="请输入微信号" />
                </Modal>

                <ChooseUserModal ref={"chooseUserModal"}/>

                <Modal
                    title="群发方式"
                    visible={this.state.publishModalVisible}
                    onOk={this.publishHandleOk}
                    onCancel={this.publishHandleCancel}
                >
                    <WeiChatTagSelect mediaCode={this.state.mediaCode} ref={that=>this.weiChatTagSelect=that}/>
                </Modal>

                <Modal
                    title={this.textareaModalTitle}
                    visible={this.state.textareaModalVisible}
                    onOk={this.textareaHandleOk}
                    onCancel={this.textareaHandleCancel}
                >
                    <TextArea ref={that => this.remarks = that} placeholder="请输入备注" />
                </Modal>
            </div>
        );
    }
}

EditMaterial.defaultProps={
    onAdvance: ()=>{}
}
export default EditMaterial;


